import * as _ from "lodash";
import http from "../constant/api";

export const profileSettingService = {
  getProfileSetting: async () => {
    const result = await http.get(`/api/profile-setting`);

    return result;
  },
  syncProfileSetting: async () => {
    const result = await http.post(`/api/profile-setting/sync`);

    return result;
  },
};
